






































import { defineComponent, ref } from '@vue/composition-api'
import { AppFieldDTO } from '@/api/types-app'
import { getAllAppFields } from '@/api/admin'
import AppField from './AppField.vue'

export default defineComponent({
  components: {
    AppField
  },
  name: 'FieldList',
  setup() {
    const loading = ref(true)
    const columns = [
      {
        prop: 'ID',
        label: 'appFieldId',
        width: 70
      },
      {
        prop: 'App FIeld Name',
        label: 'appFieldName'
      },
      {
        prop: 'Display Name Capture',
        label: 'displayNameCapture'
      },
      {
        prop: 'Display Name PDR',
        label: 'displayNamePDR'
      },
      {
        prop: 'Value Type',
        label: 'valueType.name'
      },
      {
        prop: 'Field Type',
        label: 'fieldType.displayName'
      }
    ]

    const appFields = ref<Array<AppFieldDTO>>(null)
    const activeAppField = ref<AppFieldDTO>(null)
    const activeRowIndex = ref<number>(null)

    const request = getAllAppFields()
    request.then((response) => {
      appFields.value = response.data
      loading.value = false
    })

    const handleActiveField = (row) => {
      activeRowIndex.value = appFields.value.findIndex((_row) => _row === row)
      activeAppField.value = row
    }

    return {
      loading,
      columns,
      appFields,
      activeAppField,
      activeRowIndex,
      handleActiveField
    }
  }
})
